/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Image } from "react-bootstrap";
import Cinema from "../Cinema/Cinema";

import instagramIcon from "assets/images/falabella/icons8-instagram.svg";
import linkedinIcon from "assets/images/falabella/icons8-linkedin.svg";
import iconoDescarga from "assets/images/falabella/iconodescarga.png";
import archivoDescarga from "assets/images/falabella/somosgrupofalabella.jpg";

import { OfertasLaboralesService } from "../../../../services/OfertasLaborales.service";
import spotifyLogo from "assets/images/falabella/imagenspotify.png";

const YoImpulsoMiDesarrollo = () => {
  const service = new OfertasLaboralesService();
  const [showModal, setShowModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentVideo("");
  };

  const handleOpenModal = (videoUrl) => {
    setCurrentVideo(videoUrl);
    setShowModal(true);
  };

  const spotifyLink = "https://open.spotify.com/show/3mHslVezCpJ2IJxmSbbRkC";

  return (
    <div className="container mt-5">

      {/* SECCIÓN DESCARGA */}
      <div className="text-center mb-6" style={{ marginTop: "-50px" }}>
        <a
          href={archivoDescarga}
          download="somosgrupofalabella.jpg"
          className="d-flex justify-content-center align-items-center text-decoration-none text-dark"
        >
          <Image
            src={iconoDescarga}
            alt="Descargar"
            style={{ width: "40px", height: "40px" }}
            className="me-2"
          />
          <span className="fs-7 fw-semibold">
            Conócenos más descargando el archivo
          </span>
        </a>
      </div>

      {/* TÍTULO */}
      <div
        className="bg-light p-3 mb-3 mt-4"
        style={{ borderRadius: "40px" }}
      >
        <h4
          className="text-left fw-bold"
          style={{ fontWeight: 600, fontFamily: "sans-serif" }}
        >
          <FormattedMessage id="app.impulsodesarrollo.titulo2" />
        </h4>
      </div>

{/* SECCIÓN DE VIDEOS */}
<div className="bg-light p-4 mb-3" style={{ borderRadius: "20px" }}>

  {/* Primer bloque (video izq, texto der) */}
  <div className="row align-items-center mb-4">
    {/* Columna VIDEO */}
    <div className="col-12 col-md-6 mb-3 mb-md-0 d-flex justify-content-center">
      {/* Ajusta "maxWidth" si no quieres que ocupe todo el ancho en pantallas grandes */}
      <div className="ratio ratio-16x9" style={{ maxWidth: "640px", width: "100%" }}>
        <iframe
          src="https://cdn.jwplayer.com/videos/t2ert4pX-FilykFf7.mp4"
          frameBorder="0"
          allowFullScreen
          title="Video 1"
          style={{ borderRadius: "8px" }}
        />
      </div>
    </div>

    {/* Columna TEXTO */}
    <div className="col-12 col-md-6 fs-4">
      <h1
        style={{
          fontWeight: 300,
          fontFamily: "sans-serif",
          fontSize: "1.5rem"
        }}
      >
        <FormattedMessage id="app.impulsodesarrollo.video1" />
      </h1>
    </div>
  </div>

  {/* Segundo bloque (video izq, texto der) */}
  <div className="row align-items-center">
    {/* Columna VIDEO */}
    <div className="col-12 col-md-6 mb-3 mb-md-0 d-flex justify-content-center">
      <div className="ratio ratio-16x9" style={{ maxWidth: "640px", width: "100%" }}>
        <iframe
          src="https://cdn.jwplayer.com/videos/omGD8Lc3-FilykFf7.mp4"
          frameBorder="0"
          allowFullScreen
          title="Video 2"
          style={{ borderRadius: "8px" }}
        />
      </div>
    </div>

    {/* Columna TEXTO */}
    <div className="col-12 col-md-6 fs-4">
      <h1
        style={{
          fontWeight: 300,
          fontFamily: "sans-serif",
          fontSize: "1.5rem"
        }}
      >
        <FormattedMessage id="app.impulsodesarrollo.video2" />
      </h1>
    </div>
  </div>
</div>

      {/* SECCIÓN DE TEXTO ADICIONAL */}
      <div
        className="bg-light p-3 mb-3 mt-4"
        style={{ borderRadius: "40px" }}
      >
        <h4
          className="text-left fw-bold"
          style={{ fontWeight: 600, fontFamily: "sans-serif" }}
        >
          <FormattedMessage id="app.oportunidadescolab.texto1" />
        </h4>
      </div>

      {/* SECCIÓN SPOTIFY */}
      <div
        className="bg-light p-4 d-flex align-items-center"
        style={{ borderRadius: "20px" }}
      >
        <div
          className="row w-100 align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => window.open(spotifyLink, "_blank")}
        >
          <div className="col-12 col-md-3 text-center">
            <div className="bg-light rounded-3 p-3 d-inline-block">
              <Image
                src={spotifyLogo}
                alt="Spotify Logo"
                style={{ maxWidth: "220px" }}
              />
            </div>
          </div>
          <div className="col-12 col-md-9">
            <h1
              style={{
                fontWeight: 300,
                fontFamily: "sans-serif",
                fontSize: "1.5rem"
              }}
            >
              <FormattedMessage
                id="app.impulsodesarrollo.spotify"
                values={{
                  br: <br />
                }}
              />
            </h1>
          </div>
        </div>
      </div>

      {/* SECCIÓN "SÍGUENOS" */}
      <div className="mt-3">
        <h2 className="text-left" style={{ fontWeight: 300 }}>
          <FormattedMessage id="app.impulsodesarrollo.siguenos" />
        </h2>
        <hr className="my-3" style={{ borderTop: "1px solid #ccc" }} />
        <div className="d-flex justify-content-between align-items-center">
          {/* Instagram */}
          <a
            href="https://www.instagram.com/grupo.falabella/"
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center text-decoration-none text-dark ms-9"
          >
            <Image
              src={instagramIcon}
              alt="Instagram"
              style={{ width: "50px", height: "50px" }}
              className="me-2"
            />
            <span>@GrupoFalabella</span>
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/company/grupo-falabella"
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center text-decoration-none text-dark me-9"
          >
            <Image
              src={linkedinIcon}
              alt="LinkedIn"
              style={{ width: "50px", height: "50px" }}
              className="me-2"
            />
            <span>@GrupoFalabella</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default YoImpulsoMiDesarrollo;
